import { STATUS_ATIVO } from './constants';

// MÓDULOS
const IDENTIFICADOR_MODULO_PESSOAL = 'pessoal';
const IDENTIFICADOR_MODULO_COMPRADOR = 'comprador';
const IDENTIFICADOR_MODULO_VENDAS = 'vendas';
const IDENTIFICADOR_MODULO_LOGISTICA = 'logistica';
const IDENTIFICADOR_MODULO_FISCAL = 'fiscal';
const IDENTIFICADOR_MODULO_FORNECIMENTO = 'fornecimento';
const IDENTIFICADOR_MODULO_ITENS_VENDA = 'itens_venda';
const IDENTIFICADOR_MODULO_TELEVENDAS = 'televendas';
const IDENTIFICADOR_MODULO_PROCESSOS = 'processos';
const IDENTIFICADOR_MODULO_FINANCEIRO = 'financeiro';
const IDENTIFICADOR_MODULO_MALOTES = 'malotes';
const IDENTIFICADOR_MODULO_RELATORIO = 'relatorio';
const IDENTIFICADOR_MODULO_CONTABILIDADE = 'contabilidade';
const IDENTIFICADOR_MODULO_EQUIPAMENTOS = 'equipamentos';
const IDENTIFICADOR_MODULO_SISTEMA = 'sistema';
const IDENTIFICADOR_MODULO_DEVELOPMENT = 'development';
const IDENTIFICADOR_MODULO_CONFERENCIAS = 'conferencias';
const IDENTIFICADOR_MODULO_COLETOR = 'coletor';
const IDENTIFICADOR_MODULO_DESENVOLVEDOR = 'desenvolvedor';

// TELAS - PESSOAL
const IDENTIFICADOR_TELA_ESCALAS = 'escalas';
const IDENTIFICADOR_TELA_ATIVIDADES_COLABORADOR = 'atividades_colaborador';
const IDENTIFICADOR_TELA_ATIVIDADES_GESTOR = 'atividades_gestor';
const IDENTIFICADOR_TELA_FERIADOS_PESSOAL = 'feriados';
const IDENTIFICADOR_TELA_GRADE_HORARIOS = 'grade_horarios';
const IDENTIFICADOR_TELA_QRCODES_GERENTE_CAIXA = 'qrcodes_gerente_caixa';
const IDENTIFICADOR_TELA_TROCOS_TRANSPORTADOR = 'trocos_transportador';

// TELAS - COMPRADOR
const IDENTIFICADOR_TELA_CONFIG_PRODUTOS = 'config_produtos';
const IDENTIFICADOR_TELA_BANCOS_FORNECEDORES = 'bancos_fornecedores';
const IDENTIFICADOR_TELA_FUNCOES_FUNCIONARIOS = 'funcoes_funcionarios';
const IDENTIFICADOR_TELA_JORNAIS_OFERTAS = 'jornais_ofertas';
const IDENTIFICADOR_TELA_COTACOES = 'cotacoes';
const IDENTIFICADOR_TELA_OFERTAS_ZERAR_ESTOQUE = 'ofertas_zerar_estoque';
const IDENTIFICADOR_TELA_PEDIDOS_COMPRAS = 'pedidos_compras';
const IDENTIFICADOR_TELA_REPRESENTANTES_FORNECEDORES =
  'representantes_fornecedores';

// TELAS - VENDAS
const IDENTIFICADOR_TELA_VENDAS = 'vendas';
const IDENTIFICADOR_TELA_DEVOLUCOES_VENDAS = 'devolucoes_vendas';
const IDENTIFICADOR_TELA_PEDIDOS_VENDAS = 'pedidos_vendas';
const IDENTIFICADOR_TELA_RATOEIRA = 'ratoeira';
const IDENTIFICADOR_TELA_CREDITOS_DEVOLUCAO_VENDAS =
  'creditos_devolucao_vendas';
const IDENTIFICADOR_TELA_PEDIDOS_LIBERACOES_PRECOS =
  'pedidos_liberacoes_precos';
const IDENTIFICADOR_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS =
  'aprovacoes_pedidos_liberacao_precos';
const IDENTIFICADOR_TELA_DESCARREGO_MERCADORIA = 'descarrego_mercadoria';

// TELAS - LOGISTICA
const IDENTIFICADOR_TELA_ENDERECOS_EXPOSICAO = 'enderecos_exposicao';
const IDENTIFICADOR_TELA_PRODUTOS_EXPOSICAO = 'produtos_exposicao';
const IDENTIFICADOR_TELA_SAIDAS_ENDERECOS_EXPOSICAO =
  'saidas_enderecos_exposicao';
const IDENTIFICADOR_TELA_SAIDAS_EMPILHADOR = 'saidas_empilhador';
const IDENTIFICADOR_TELA_MAPAS_LOJA = 'mapas_loja';
const IDENTIFICADOR_TELA_EXPOSICAO_LOJA = 'exposicao_loja';

// TELAS - FISCAL
const IDENTIFICADOR_TELA_NFCES = 'nfces';
const IDENTIFICADOR_TELA_INDICADORES_NFCE = 'indicadores_nfce';
const IDENTIFICADOR_TELA_NFES = 'nfes';
const IDENTIFICADOR_TELA_INDICADORES_NFE = 'indicadores_nfe';
const IDENTIFICADOR_TELA_INDICADORES_FISCAIS = 'indicadores_fiscais';
const IDENTIFICADOR_TELA_RELATORIOS_FISCAIS = 'relatorios_fiscais';

// TELAS - FORNECIMENTO
const IDENTIFICADOR_TELA_COMPRAS = 'compras';
const IDENTIFICADOR_TELA_COMPRAS_INSUMOS = 'compras_insumos';
const IDENTIFICADOR_TELA_BONIFICACOES = 'bonificacoes';
const IDENTIFICADOR_TELA_COMPRAS_SERVICOS = 'compras_servicos';
const IDENTIFICADOR_TELA_NFES_CIENTES = 'nfes_cientes';
const IDENTIFICADOR_TELA_NFES_PROBLEMATICAS = 'nfes_problematicas';
const IDENTIFICADOR_TELA_FORNECEDORES = 'fornecedores';
const IDENTIFICADOR_TELA_FORNECEDORES_INSUMOS = 'fornecedores_insumos';
const IDENTIFICADOR_TELA_FORNECEDORES_SERVICOS = 'fornecedores_servicos';
const IDENTIFICADOR_TELA_OUTROS_CONTATOS = 'outros_contatos';
const IDENTIFICADOR_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES =
  'agendamento_compras_fornecedores';

// TELAS - ITENS VENDA
const IDENTIFICADOR_TELA_PRODUTOS = 'produtos';
const IDENTIFICADOR_TELA_FAMILIAS = 'familias';
const IDENTIFICADOR_TELA_CATEGORIAS = 'categorias';
const IDENTIFICADOR_TELA_TARAS_BALANCA = 'taras_balanca';
const IDENTIFICADOR_TELA_TABELA_LUCRO = 'tabela_lucro';
const IDENTIFICADOR_TELA_BAIXAR = 'baixar';
const IDENTIFICADOR_TELA_LOCAIS = 'locais';
const IDENTIFICADOR_TELA_SUGESTAO_PRODUTOS = 'sugestao_produtos';
const IDENTIFICADOR_TELA_SETORES = 'setores';
const IDENTIFICADOR_TELA_VERIFICACAO_CAIXARIA = 'verificacao_caixaria';
const IDENTIFICADOR_TELA_LIBERACOES_PRECO = 'liberacoes_preco';
const IDENTIFICADOR_TELA_CONFERENCIAS_GRANDES_PESAGENS =
  'conferencias_grandes_pesagens';
const IDENTIFICADOR_TELA_HISTORICO_PRECIFICACOES = 'historico_precificacoes';
const IDENTIFICADOR_TELA_VERBAS_PRODUTOS = 'verbas_produtos';
const IDENTIFICADOR_TELA_VALIDADES = 'validades';
const IDENTIFICADOR_TELA_NOTAS_FISCAIS_TESTE = 'notas_fiscais_teste';
const IDENTIFICADOR_TELA_MOVIMENTACAO_ESTOQUE = 'movimentacao_estoque';
const IDENTIFICADOR_TELA_CONFERENCIAS_PRODUTOS = 'conferencias_produtos';

// TELAS - TELEVENDAS
const IDENTIFICADOR_TELA_CLIENTES = 'clientes';
const IDENTIFICADOR_TELA_CATEGORIAS_CLIENTES = 'categorias_clientes';

// TELAS - PROCESSOS
const IDENTIFICADOR_TELA_ATIVIDADES_TEMPLATES = 'atividades_templates';
const IDENTIFICADOR_TELA_ATIVIDADES = 'atividades';

// TELAS - FINANCEIRO
const IDENTIFICADOR_TELA_DASHBOARD = 'dashboard';
const IDENTIFICADOR_TELA_SESSOES = 'sessoes';
const IDENTIFICADOR_TELA_CONTAS = 'contas';
const IDENTIFICADOR_TELA_CAIXAS = 'caixas';
const IDENTIFICADOR_TELA_CONTAS_TABELA = 'contas_tabela';
const IDENTIFICADOR_TELA_VERIFICACAO_NOTAS_VENDAS = 'verificacao_notas_vendas';
const IDENTIFICADOR_TELA_CARTOES_CREDITO = 'cartoes_credito';
const IDENTIFICADOR_TELA_TRANSACOES = 'transacoes';
const IDENTIFICADOR_TELA_TRANSACOES_CONFERENCIA = 'transacoes_conferencia';
const IDENTIFICADOR_TELA_PIX = 'pix';
const IDENTIFICADOR_TELA_TRANSFERENCIAS = 'transferencias';
const IDENTIFICADOR_TELA_AJUSTES = 'ajustes';
const IDENTIFICADOR_TELA_CATEGORIAS_TRANSACOES = 'categorias_transacoes';
const IDENTIFICADOR_TELA_FUTUROLOGIA = 'futurologia';
const IDENTIFICADOR_TELA_TRANSACOES_SIMULADAS = 'transacoes_simuladas';
const IDENTIFICADOR_TELA_VENDAS_FATURADAS = 'vendas_faturadas';
const IDENTIFICADOR_TELA_AGENDAMENTOS = 'agendamentos';
const IDENTIFICADOR_TELA_CONFERENCIAS_MAQUINETAS = 'conferencias_maquinetas';
const IDENTIFICADOR_TELA_IMPOSTOS = 'impostos';

// TELAS - MALOTES
const IDENTIFICADOR_TELA_MALOTES = 'malotes';
const IDENTIFICADOR_TELA_SUBMALOTES = 'submalotes';
const IDENTIFICADOR_TELA_SANGRIAS = 'sangrias';
const IDENTIFICADOR_TELA_TROCOS = 'trocos';
const IDENTIFICADOR_TELA_SOBRAS = 'sobras';
const IDENTIFICADOR_TELA_SINISTROS = 'sinistros';
const IDENTIFICADOR_TELA_CONTA_GERENCIAL = 'conta_gerencial';
const IDENTIFICADOR_TELA_LIXEIRA = 'lixeira';

// TELAS - RELATÓRIO
const IDENTIFICADOR_TELA_MENSAL = 'mensal';
const IDENTIFICADOR_TELA_ANUAL = 'anual';
const IDENTIFICADOR_TELA_PRODUTOS_RELATORIO = 'produtos';
const IDENTIFICADOR_TELA_CLIENTES_RELATORIO = 'clientes';
const IDENTIFICADOR_TELA_INDICADORES_KPI = 'indicadores_kpi';
const IDENTIFICADOR_TELA_INVENTARIO = 'inventario';
const IDENTIFICADOR_TELA_CADASTRO_CLIENTES = 'cadastro_clientes';
const IDENTIFICADOR_TELA_PRODUTOS_LOCAL = 'produtos_local';
const IDENTIFICADOR_TELA_PRODUTOS_COLABORADOR = 'produtos_colaborador';
const IDENTIFICADOR_TELA_FARDAMENTOS_COLABORADORES =
  'fardamentos_colaboradores';
const IDENTIFICADOR_TELA_CARTOES = 'cartoes';
const IDENTIFICADOR_TELA_FLUXO_CAIXA = 'fluxo_caixa';
const IDENTIFICADOR_TELA_SCORES = 'scores';
const IDENTIFICADOR_TELA_VENDAS_NAO_FINALIZADAS = 'vendas_nao_finalizadas';
const IDENTIFICADOR_TELA_ITENS_VENDA_NAO_FINALIZADOS =
  'itens_venda_nao_finalizados';
const IDENTIFICADOR_TELA_COMPRAS_FISCAIS = 'compras_fiscais';

// TELAS - CONTABILIDADE
const IDENTIFICADOR_TELA_FERIADOS = 'feriados';
const IDENTIFICADOR_TELA_COLABORADORES = 'colaboradores';
const IDENTIFICADOR_TELA_MODELOS_DOCUMENTOS = 'modelos_documentos';
const IDENTIFICADOR_TELA_DOCUMENTOS = 'documentos';
const IDENTIFICADOR_TELA_FUNCOES = 'funcoes';
const IDENTIFICADOR_TELA_CHECAGEM_CAMISAS = 'checagem_camisas';
const IDENTIFICADOR_TELA_FARDAMENTOS = 'fardamentos';
const IDENTIFICADOR_TELA_TAMANHOS_FARDAMENTOS = 'tamanhos_fardamentos';
const IDENTIFICADOR_TELA_QUALIDADES = 'qualidades';
const IDENTIFICADOR_TELA_DEFEITOS = 'defeitos';
const IDENTIFICADOR_TELA_DESCONTOS_FUNCIONARIOS = 'descontos_funcionarios';
const IDENTIFICADOR_TELA_CATEGORIA_DESCONTOS = 'categoria_descontos';
const IDENTIFICADOR_TELA_GRUPOS_COLABORADORES = 'grupos_colaboradores';
const IDENTIFICADOR_TELA_EQUIPES_COLABORADORES = 'equipes_colaboradores';
const IDENTIFICADOR_TELA_CODINOMES_COLABORADORES = 'codinomes_colaboradores';
const IDENTIFICADOR_TELA_PRODUTOS_CODINOMES = 'produtos_codinomes';
const IDENTIFICADOR_TELA_DEPARTAMENTOS_COLABORADORES =
  'departamentos_colaboradores';
const IDENTIFICADOR_TELA_HORAS_EXTRAS = 'horas_extras';

// TELAS - EQUIPAMENTOS
const IDENTIFICADOR_TELA_FREEZERS = 'freezers';

// TELAS - SISTEMA
const IDENTIFICADOR_TELA_MEIO_PAGAMENTO = 'meio_pagamento';
const IDENTIFICADOR_TELA_UNIDADES = 'unidades';
const IDENTIFICADOR_TELA_CARGOS_SISTEMA = 'cargos_sistema';
const IDENTIFICADOR_TELA_USUARIOS = 'usuarios';
const IDENTIFICADOR_TELA_PERGUNTAS = 'perguntas';
const IDENTIFICADOR_TELA_CATEGORIA_PERGUNTA = 'categoria_pergunta';
const IDENTIFICADOR_TELA_CATEGORIAS_CAIXAS = 'categorias_caixas';
const IDENTIFICADOR_TELA_CATEGORIAS_PROBLEMAS = 'categorias_problemas';
const IDENTIFICADOR_TELA_CONFIGURACOES = 'configuracoes';
const IDENTIFICADOR_TELA_VIDEOS_TUTORIAIS_FC = 'videos_tutoriais_fc';
const IDENTIFICADOR_TELA_ESTADOS_BRASILEIROS = 'estados_brasileiros';
const IDENTIFICADOR_TELA_LOJAS = 'lojas';
const IDENTIFICADOR_TELA_TABELA_IBPT = 'tabela_ibpt';
const IDENTIFICADOR_TELA_NCMS = 'ncms';
const IDENTIFICADOR_TELA_TABELA_CST_IBSCBS = 'tabela_cst_ibscbs';
const IDENTIFICADOR_TELA_TABELA_CCLASSTRIB = 'tabela_cclasstrib';
const IDENTIFICADOR_TELA_PERFIS = 'perfis';

// TELAS - DEVELOPMENT
const IDENTIFICADOR_TELA_FEATURES = 'features';
const IDENTIFICADOR_TELA_SOFTWARES = 'softwares';

// TELAS - CONFERÊNCIAS
const IDENTIFICADOR_TELA_CONFERENCIAS_FREEZERS = 'conferencias_freezers';

// TELAS - COLETOR
const IDENTIFICADOR_TELA_ETIQUETAS_GONDOLA = 'etiquetas_gondola';
const IDENTIFICADOR_TELA_CONFERENCIA_TEMPERATURA_FREEZERS =
  'conferencia_temperatura_freezers';
const IDENTIFICADOR_TELA_CARTAZES_OFERTA = 'cartazes_oferta';

// TELAS - DESENVOLVEDOR
const IDENTIFICADOR_TELA_LOGS_RELATORIOS = 'logs_relatorios';
const IDENTIFICADOR_TELA_DADOS_FISCAIS_CHECKOUT = 'dados_fiscais_checkout';
const IDENTIFICADOR_TELA_COMPUTADORES_AUTORIZADOS = 'computadores_autorizados';

/// ////////////

const IDENTIFICADOR_APP_GERENCIAL = 'gerencial';

/// /////////////chaves

// TELAS - PESSOAL
const PERMISSAO_TELA_ESCALAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PESSOAL}.${IDENTIFICADOR_TELA_ESCALAS}.listar`;
const PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PESSOAL}.${IDENTIFICADOR_TELA_ATIVIDADES_COLABORADOR}.listar`;
const PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PESSOAL}.${IDENTIFICADOR_TELA_ATIVIDADES_GESTOR}.listar`;
const PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PESSOAL}.${IDENTIFICADOR_TELA_FERIADOS_PESSOAL}.listar`;
const PERMISSAO_TELA_GRADE_HORARIOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PESSOAL}.${IDENTIFICADOR_TELA_GRADE_HORARIOS}.listar`;
const PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PESSOAL}.${IDENTIFICADOR_TELA_QRCODES_GERENTE_CAIXA}.listar`;
const PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PESSOAL}.${IDENTIFICADOR_TELA_TROCOS_TRANSPORTADOR}.listar`;

// TELAS - COMPRADOR
const PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_CONFIG_PRODUTOS}.listar`;
const PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_BANCOS_FORNECEDORES}.listar`;
const PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_FUNCOES_FUNCIONARIOS}.listar`;
const PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_JORNAIS_OFERTAS}.listar`;
const PERMISSAO_TELA_COTACOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_COTACOES}.listar`;
const PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_OFERTAS_ZERAR_ESTOQUE}.listar`;
const PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_PEDIDOS_COMPRAS}.listar`;
const PERMISSAO_TELA_PEDIDOS_COMPRAS_ACOES = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_PEDIDOS_COMPRAS}.acoes`;
const PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_REPRESENTANTES_FORNECEDORES}.listar`;

// TELAS - VENDAS
const PERMISSAO_TELA_VENDAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_VENDAS}.listar`;
const PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_DEVOLUCOES_VENDAS}.listar`;
const PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_PEDIDOS_VENDAS}.listar`;
const PERMISSAO_TELA_RATOEIRA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_RATOEIRA}.listar`;
const PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_CREDITOS_DEVOLUCAO_VENDAS}.listar`;
const PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_PEDIDOS_LIBERACOES_PRECOS}.listar`;
const PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS}.listar`;
const PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_VENDAS}.${IDENTIFICADOR_TELA_DESCARREGO_MERCADORIA}.listar`;

// TELAS - LOGISTICA
const PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_LOGISTICA}.${IDENTIFICADOR_TELA_ENDERECOS_EXPOSICAO}.listar`;
const PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_LOGISTICA}.${IDENTIFICADOR_TELA_PRODUTOS_EXPOSICAO}.listar`;
const PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_LOGISTICA}.${IDENTIFICADOR_TELA_SAIDAS_ENDERECOS_EXPOSICAO}.listar`;
const PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_LOGISTICA}.${IDENTIFICADOR_TELA_SAIDAS_EMPILHADOR}.listar`;
const PERMISSAO_TELA_MAPAS_LOJA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_LOGISTICA}.${IDENTIFICADOR_TELA_MAPAS_LOJA}.listar`;
const PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_LOGISTICA}.${IDENTIFICADOR_TELA_EXPOSICAO_LOJA}.listar`;

// TELAS - FISCAL
const PERMISSAO_TELA_NFCES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_NFCES}.listar`;
const PERMISSAO_TELA_INDICADORES_NFCE_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_INDICADORES_NFCE}.listar`;
const PERMISSAO_TELA_NFES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_NFES}.listar`;
const PERMISSAO_TELA_INDICADORES_NFE_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_INDICADORES_NFE}.listar`;
const PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_INDICADORES_FISCAIS}.listar`;
const PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_RELATORIOS_FISCAIS}.listar`;
const PERMISSAO_TELA_RELATORIOS_FISCAIS_GERAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_RELATORIOS_FISCAIS}.gerar`;
const PERMISSAO_TELA_RELATORIOS_FISCAIS_REPROCESSAR_FORCADO = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FISCAL}.${IDENTIFICADOR_TELA_RELATORIOS_FISCAIS}.reprocessar_forcado`;

// TELAS - FORNECIMENTO
const PERMISSAO_TELA_COMPRAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_COMPRAS}.listar`;
const PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_COMPRAS_INSUMOS}.listar`;
const PERMISSAO_TELA_BONIFICACOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_BONIFICACOES}.listar`;
const PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_COMPRAS_SERVICOS}.listar`;
const PERMISSAO_TELA_NFES_CIENTES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_NFES_CIENTES}.listar`;
const PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_NFES_PROBLEMATICAS}.listar`;
const PERMISSAO_TELA_FORNECEDORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_FORNECEDORES}.listar`;
const PERMISSAO_TELA_FORNECEDORES_DIALOGOS_ABA_COMPRADOR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_FORNECEDORES}.dialogos.aba_comprador`;
const PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_FORNECEDORES_INSUMOS}.listar`;
const PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_FORNECEDORES_SERVICOS}.listar`;
const PERMISSAO_TELA_OUTROS_CONTATOS = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FORNECIMENTO}.${IDENTIFICADOR_TELA_OUTROS_CONTATOS}.listar`;
const PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COMPRADOR}.${IDENTIFICADOR_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES}.listar`;

// TELAS - ITENS VENDA
const PERMISSAO_TELA_PRODUTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_PRODUTOS}.listar`;
const PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_COMPRADOR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_PRODUTOS}.dialogos.aba_comprador`;
const PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_IMPOSTOS = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_PRODUTOS}.dialogos.aba_impostos`;
const PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_FORNECEDOR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_PRODUTOS}.dialogos.aba_fornecedor`;
// Ações da tela de Produtos: criar, inativar e ver a aba "Inativos". Ficam FORA de
// `permissoesMigration1` (ver comentário no fim do array): têm migration própria.
const PERMISSAO_TELA_PRODUTOS_CRIAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_PRODUTOS}.criar`;
const PERMISSAO_TELA_PRODUTOS_INATIVAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_PRODUTOS}.inativar`;
const PERMISSAO_TELA_PRODUTOS_ABA_INATIVOS = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_PRODUTOS}.aba_inativos`;
const PERMISSAO_TELA_FAMILIAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_FAMILIAS}.listar`;
const PERMISSAO_TELA_CATEGORIAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_CATEGORIAS}.listar`;
const PERMISSAO_TELA_TARAS_BALANCA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_TARAS_BALANCA}.listar`;
const PERMISSAO_TELA_TABELA_LUCRO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_TABELA_LUCRO}.listar`;
const PERMISSAO_TELA_BAIXAR_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_BAIXAR}.listar`;
const PERMISSAO_TELA_LOCAIS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_LOCAIS}.listar`;
const PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_SUGESTAO_PRODUTOS}.listar`;
const PERMISSAO_TELA_SETORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_SETORES}.listar`;
const PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_VERIFICACAO_CAIXARIA}.listar`;
const PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_LIBERACOES_PRECO}.listar`;
const PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_CONFERENCIAS_GRANDES_PESAGENS}.listar`;
const PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_HISTORICO_PRECIFICACOES}.listar`;
const PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_VERBAS_PRODUTOS}.listar`;
const PERMISSAO_TELA_VALIDADES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_VALIDADES}.listar`;
const PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_NOTAS_FISCAIS_TESTE}.listar`;
const PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_MOVIMENTACAO_ESTOQUE}.listar`;
const PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_ITENS_VENDA}.${IDENTIFICADOR_TELA_CONFERENCIAS_PRODUTOS}.listar`;

// TELAS - TELEVENDAS
const PERMISSAO_TELA_CLIENTES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_TELEVENDAS}.${IDENTIFICADOR_TELA_CLIENTES}.listar`;
const PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_TELEVENDAS}.${IDENTIFICADOR_TELA_CATEGORIAS_CLIENTES}.listar`;

// TELAS - PROCESSOS
const PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PROCESSOS}.${IDENTIFICADOR_TELA_ATIVIDADES_TEMPLATES}.listar`;
const PERMISSAO_TELA_ATIVIDADES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_PROCESSOS}.${IDENTIFICADOR_TELA_ATIVIDADES}.listar`;

// TELAS - FINANCEIRO
const PERMISSAO_TELA_DASHBOARD_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_DASHBOARD}.listar`;
const PERMISSAO_TELA_SESSOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_SESSOES}.listar`;
const PERMISSAO_TELA_CONTAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_CONTAS}.listar`;
const PERMISSAO_TELA_CAIXAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_CAIXAS}.listar`;
const PERMISSAO_TELA_CONTAS_TABELA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_CONTAS_TABELA}.listar`;
const PERMISSAO_TELA_CONTAS_TABELA_EDITAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_CONTAS_TABELA}.editar`;
const PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_VERIFICACAO_NOTAS_VENDAS}.listar`;
const PERMISSAO_TELA_CARTOES_CREDITO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_CARTOES_CREDITO}.listar`;
const PERMISSAO_TELA_TRANSACOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_TRANSACOES}.listar`;
const PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_TRANSACOES_CONFERENCIA}.listar`;
const PERMISSAO_TELA_PIX_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_PIX}.listar`;
const PERMISSAO_TELA_TRANSFERENCIAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_TRANSFERENCIAS}.listar`;
const PERMISSAO_TELA_AJUSTES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_AJUSTES}.listar`;
const PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_CATEGORIAS_TRANSACOES}.listar`;
const PERMISSAO_TELA_FUTUROLOGIA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_FUTUROLOGIA}.listar`;
const PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_TRANSACOES_SIMULADAS}.listar`;
const PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_VENDAS_FATURADAS}.listar`;
const PERMISSAO_TELA_AGENDAMENTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_AGENDAMENTOS}.listar`;
const PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_CONFERENCIAS_MAQUINETAS}.listar`;
const PERMISSAO_TELA_IMPOSTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_FINANCEIRO}.${IDENTIFICADOR_TELA_IMPOSTOS}.listar`;

// TELAS - MALOTES
const PERMISSAO_TELA_MALOTES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_MALOTES}.listar`;
const PERMISSAO_TELA_SUBMALOTES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_SUBMALOTES}.listar`;
const PERMISSAO_TELA_SANGRIAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_SANGRIAS}.listar`;
const PERMISSAO_TELA_TROCOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_TROCOS}.listar`;
const PERMISSAO_TELA_SOBRAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_SOBRAS}.listar`;
const PERMISSAO_TELA_SINISTROS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_SINISTROS}.listar`;
const PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_CONTA_GERENCIAL}.listar`;
const PERMISSAO_TELA_LIXEIRA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_MALOTES}.${IDENTIFICADOR_TELA_LIXEIRA}.listar`;

// TELAS - RELATÓRIO
const PERMISSAO_TELA_MENSAL_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_MENSAL}.listar`;
const PERMISSAO_TELA_ANUAL_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_ANUAL}.listar`;
const PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_PRODUTOS_RELATORIO}.listar`;
const PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_CLIENTES_RELATORIO}.listar`;
const PERMISSAO_TELA_INDICADORES_KPI_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_INDICADORES_KPI}.listar`;
const PERMISSAO_TELA_INVENTARIO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_INVENTARIO}.listar`;
const PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_CADASTRO_CLIENTES}.listar`;
const PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_PRODUTOS_LOCAL}.listar`;
const PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_PRODUTOS_COLABORADOR}.listar`;
const PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_FARDAMENTOS_COLABORADORES}.listar`;
const PERMISSAO_TELA_CARTOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_CARTOES}.listar`;
const PERMISSAO_TELA_FLUXO_CAIXA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_FLUXO_CAIXA}.listar`;
const PERMISSAO_TELA_SCORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_SCORES}.listar`;
const PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_VENDAS_NAO_FINALIZADAS}.listar`;
const PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_ITENS_VENDA_NAO_FINALIZADOS}.listar`;
const PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_RELATORIO}.${IDENTIFICADOR_TELA_COMPRAS_FISCAIS}.listar`;

// TELAS - CONTABILIDADE

const PERMISSAO_TELA_COLABORADORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_COLABORADORES}.listar`;
const PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_MODELOS_DOCUMENTOS}.listar`;
const PERMISSAO_TELA_DOCUMENTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_DOCUMENTOS}.listar`;
const PERMISSAO_TELA_DOCUMENTOS_EXCLUIR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_DOCUMENTOS}.excluir`;
const PERMISSAO_TELA_FUNCOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_FUNCOES}.listar`;
const PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_CHECAGEM_CAMISAS}.listar`;
const PERMISSAO_TELA_FARDAMENTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_FARDAMENTOS}.listar`;
const PERMISSAO_TELA_FERIADOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_FERIADOS}.listar`;
const PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_TAMANHOS_FARDAMENTOS}.listar`;
const PERMISSAO_TELA_QUALIDADES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_QUALIDADES}.listar`;
const PERMISSAO_TELA_DEFEITOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_DEFEITOS}.listar`;
const PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_DESCONTOS_FUNCIONARIOS}.listar`;
const PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_CATEGORIA_DESCONTOS}.listar`;
const PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_GRUPOS_COLABORADORES}.listar`;
const PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_EQUIPES_COLABORADORES}.listar`;
const PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_CODINOMES_COLABORADORES}.listar`;
const PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_PRODUTOS_CODINOMES}.listar`;
const PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_DEPARTAMENTOS_COLABORADORES}.listar`;
const PERMISSAO_TELA_HORAS_EXTRAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONTABILIDADE}.${IDENTIFICADOR_TELA_HORAS_EXTRAS}.listar`;

// TELAS - EQUIPAMENTOS
const PERMISSAO_TELA_FREEZERS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_EQUIPAMENTOS}.${IDENTIFICADOR_TELA_FREEZERS}.listar`;

// TELAS - SISTEMA
const PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_MEIO_PAGAMENTO}.listar`;
const PERMISSAO_TELA_UNIDADES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_UNIDADES}.listar`;
const PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_CARGOS_SISTEMA}.listar`;
const PERMISSAO_TELA_USUARIOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_USUARIOS}.listar`;
const PERMISSAO_TELA_PERGUNTAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_PERGUNTAS}.listar`;
const PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_CATEGORIA_PERGUNTA}.listar`;
const PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_CATEGORIAS_CAIXAS}.listar`;
const PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_CATEGORIAS_PROBLEMAS}.listar`;
const PERMISSAO_TELA_CONFIGURACOES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_CONFIGURACOES}.listar`;
const PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_VIDEOS_TUTORIAIS_FC}.listar`;
const PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_ESTADOS_BRASILEIROS}.listar`;
const PERMISSAO_TELA_LOJAS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_LOJAS}.listar`;
const PERMISSAO_TELA_TABELA_IBPT_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_TABELA_IBPT}.listar`;
const PERMISSAO_TELA_NCMS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_NCMS}.listar`;
const PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_TABELA_CST_IBSCBS}.listar`;
const PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_TABELA_CCLASSTRIB}.listar`;
const PERMISSAO_TELA_PERFIS = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_SISTEMA}.${IDENTIFICADOR_TELA_PERFIS}.listar`;

// TELAS - DEVELOPMENT
const PERMISSAO_TELA_FEATURES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_DEVELOPMENT}.${IDENTIFICADOR_TELA_FEATURES}.listar`;
const PERMISSAO_TELA_SOFTWARES_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_DEVELOPMENT}.${IDENTIFICADOR_TELA_SOFTWARES}.listar`;

// TELAS - CONFERÊNCIAS
const PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_CONFERENCIAS}.${IDENTIFICADOR_TELA_CONFERENCIAS_FREEZERS}.listar`;

// TELAS - COLETOR
const PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COLETOR}.${IDENTIFICADOR_TELA_ETIQUETAS_GONDOLA}.listar`;
const PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COLETOR}.${IDENTIFICADOR_TELA_CONFERENCIA_TEMPERATURA_FREEZERS}.listar`;
const PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_COLETOR}.${IDENTIFICADOR_TELA_CARTAZES_OFERTA}.listar`;

// TELAS - DESENVOLVEDOR
const PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_DESENVOLVEDOR}.${IDENTIFICADOR_TELA_LOGS_RELATORIOS}.listar`;
const PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_DESENVOLVEDOR}.${IDENTIFICADOR_TELA_DADOS_FISCAIS_CHECKOUT}.listar`;
const PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR = `${IDENTIFICADOR_APP_GERENCIAL}.${IDENTIFICADOR_MODULO_DESENVOLVEDOR}.${IDENTIFICADOR_TELA_COMPUTADORES_AUTORIZADOS}.listar`;

const permissoesMigration1 = [
  {
    chave: PERMISSAO_TELA_ESCALAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Pessoal|Escalas|Listar',
  },
  {
    chave: PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Pessoal|Atividades Colaborador|Listar',
  },
  {
    chave: PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Pessoal|Atividades Gestor|Listar',
  },
  {
    chave: PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Pessoal|Feriados|Listar',
  },
  {
    chave: PERMISSAO_TELA_GRADE_HORARIOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Pessoal|Grade de Horários|Listar',
  },
  {
    chave: PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Pessoal|Qrcodes Gerentes de Caixa|Listar',
  },
  {
    chave: PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Pessoal|Trocos Transportador|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Config Produtos|Listar',
  },
  {
    chave: PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Bancos Fornecedores|Listar',
  },
  {
    chave: PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Funções Funcionários|Listar',
  },
  {
    chave: PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Jornais de Ofertas|Listar',
  },
  {
    chave: PERMISSAO_TELA_COTACOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Cotações|Listar',
  },
  {
    chave: PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Ofertas de Zerar Estoque|Listar',
  },
  {
    chave: PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Pedidos de Compra|Listar',
  },
  {
    chave: PERMISSAO_TELA_PEDIDOS_COMPRAS_ACOES,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Pedidos de Compra|Ações',
  },
  {
    chave: PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Representantes de Fornecedores|Listar',
  },
  /// /////
  {
    chave: PERMISSAO_TELA_VENDAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Vendas|Listar',
  },
  {
    chave: PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Devoluções de Vendas|Listar',
  },
  {
    chave: PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Pedidos de Vendas|Listar',
  },
  {
    chave: PERMISSAO_TELA_RATOEIRA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Ratoeria|Listar',
  },
  {
    chave: PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Créditos de Devolução de Vendas|Listar',
  },
  {
    chave: PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Pedidos de Liberações de Preço|Listar',
  },
  {
    chave: PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Aprovações de Pedidos de Venda|Listar',
  },
  {
    chave: PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Vendas|Descarrego de Mercadoria|Listar',
  },
  /// /////////
  {
    chave: PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Logística|Endereços|Listar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Logística|Produtos Expostos|Listar',
  },
  {
    chave: PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Logística|Mov. Endereços|Listar',
  },
  {
    chave: PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Logística|Saídas Empilhador|Listar',
  },
  {
    chave: PERMISSAO_TELA_MAPAS_LOJA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Logística|Mapas da Loja|Listar',
  },
  {
    chave: PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Logística|Exposição em Loja|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_NFCES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Nfces|Listar',
  },
  {
    chave: PERMISSAO_TELA_NFES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Nfes|Listar',
  },
  {
    chave: PERMISSAO_TELA_INDICADORES_NFE_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Indicadores de Nfes|Listar',
  },
  {
    chave: PERMISSAO_TELA_INDICADORES_NFCE_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Indicadores de Nfces|Listar',
  },
  {
    chave: PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Indicadores Fiscais|Listar',
  },
  {
    chave: PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Relatórios Fiscais|Listar',
  },
  {
    chave: PERMISSAO_TELA_RELATORIOS_FISCAIS_GERAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Relatórios Fiscais|Gerar',
  },
  {
    chave: PERMISSAO_TELA_RELATORIOS_FISCAIS_REPROCESSAR_FORCADO,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fiscal|Relatórios Fiscais|Reprocessar forçado',
  },
  //
  {
    chave: PERMISSAO_TELA_COMPRAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Compras|Listar',
  },
  {
    chave: PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Compras de Insumos|Listar',
  },
  {
    chave: PERMISSAO_TELA_BONIFICACOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Bonificações|Listar',
  },
  {
    chave: PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Compras de Serviços|Listar',
  },
  {
    chave: PERMISSAO_TELA_NFES_CIENTES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Nfe Cientes|Listar',
  },
  {
    chave: PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Nfe Problemáticas|Listar',
  },
  {
    chave: PERMISSAO_TELA_FORNECEDORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Fornecedores|Listar',
  },
  {
    chave: PERMISSAO_TELA_FORNECEDORES_DIALOGOS_ABA_COMPRADOR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Fornecedores|Dialogos|Aba Comprador',
  },
  {
    chave: PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Fornecedores de Insumos|Listar',
  },
  {
    chave: PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Fornecedores de Serviços|Listar',
  },
  {
    chave: PERMISSAO_TELA_OUTROS_CONTATOS,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Fornecimento|Outros Contatos|Listar',
  },
  {
    chave: PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Comprador|Agendamento de Compras|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_PRODUTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Produtos|Listar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_COMPRADOR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Produtos|Dialogos|Aba Comprador',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_IMPOSTOS,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Produtos|Dialogos|Aba Impostos',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_FORNECEDOR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Produtos|Dialogos|Aba Fornecedor',
  },
  /// ///
  {
    chave: PERMISSAO_TELA_FAMILIAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Famílias|Listar',
  },
  {
    chave: PERMISSAO_TELA_CATEGORIAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Categorias|Listar',
  },
  {
    chave: PERMISSAO_TELA_TARAS_BALANCA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Taras de Balança|Listar',
  },
  {
    chave: PERMISSAO_TELA_TABELA_LUCRO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Tabela de Lucro|Listar',
  },
  {
    chave: PERMISSAO_TELA_BAIXAR_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Baixar|Listar',
  },
  {
    chave: PERMISSAO_TELA_LOCAIS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Locais|Listar',
  },
  {
    chave: PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Sugestão de Produtos|Listar',
  },
  {
    chave: PERMISSAO_TELA_SETORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Setores|Listar',
  },
  {
    chave: PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Verificação de Caixarias|Listar',
  },
  {
    chave: PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Liberações de Preço|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR,
    status: STATUS_ATIVO,
    descricao:
      'Gerencial|Itens de Venda|Conferência de Grandes Pesagens|Listar',
  },
  {
    chave: PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Histórico de Precificações|Listar',
  },
  {
    chave: PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Verbas de Produtos|Listar',
  },
  {
    chave: PERMISSAO_TELA_VALIDADES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Validades|Listar',
  },
  {
    chave: PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Notas Fiscais de Teste|Listar',
  },
  {
    chave: PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Movimentações de Estoque|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Conferências de Produtos|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_CLIENTES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Televendas|Clientes|Listar',
  },
  {
    chave: PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Televendas|Categorias de Produtos|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Processos|Atividades Templates|Listar',
  },
  {
    chave: PERMISSAO_TELA_ATIVIDADES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Processos|Atividades|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_DASHBOARD_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Dashboard|Listar',
  },
  {
    chave: PERMISSAO_TELA_SESSOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Sessões|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONTAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Contas|Listar',
  },
  {
    chave: PERMISSAO_TELA_CAIXAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Caixas|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONTAS_TABELA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Contas Tabela|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONTAS_TABELA_EDITAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Contas Tabela|Editar',
  },
  {
    chave: PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Verificação Notas de Vendas|Listar',
  },
  {
    chave: PERMISSAO_TELA_CARTOES_CREDITO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Cartões de Crédito|Listar',
  },
  {
    chave: PERMISSAO_TELA_TRANSACOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Transações|Listar',
  },
  {
    chave: PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Transações Conferência|Listar',
  },
  {
    chave: PERMISSAO_TELA_PIX_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Pix|Listar',
  },
  {
    chave: PERMISSAO_TELA_TRANSFERENCIAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Transferências|Listar',
  },
  {
    chave: PERMISSAO_TELA_AJUSTES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Ajustes|Listar',
  },
  {
    chave: PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Categorias de Transações|Listar',
  },
  {
    chave: PERMISSAO_TELA_FUTUROLOGIA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Futurologia|Listar',
  },
  {
    chave: PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Transações Simuladas|Listar',
  },
  {
    chave: PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Vendas Faturadas|Listar',
  },
  {
    chave: PERMISSAO_TELA_AGENDAMENTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Agendamentos|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Conferências de Maquinetas|Listar',
  },
  {
    chave: PERMISSAO_TELA_IMPOSTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Financeiro|Impostos|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_MALOTES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Malotes|Listar',
  },
  {
    chave: PERMISSAO_TELA_SUBMALOTES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Submalotes|Listar',
  },
  {
    chave: PERMISSAO_TELA_SANGRIAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Sangrias|Listar',
  },
  {
    chave: PERMISSAO_TELA_TROCOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Trocos|Listar',
  },
  {
    chave: PERMISSAO_TELA_SOBRAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Sobras|Listar',
  },
  {
    chave: PERMISSAO_TELA_SINISTROS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Sinistros|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Conta Gerencial|Listar',
  },
  {
    chave: PERMISSAO_TELA_LIXEIRA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Malotes|Lixeira|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_MENSAL_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Mensal|Listar',
  },
  {
    chave: PERMISSAO_TELA_ANUAL_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Anual|Listar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Produtos|Listar',
  },
  {
    chave: PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Clientes|Listar',
  },
  {
    chave: PERMISSAO_TELA_INDICADORES_KPI_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Indicadores KPI|Listar',
  },
  {
    chave: PERMISSAO_TELA_INVENTARIO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Inventário|Listar',
  },
  {
    chave: PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Cadastro de Clientes|Listar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Produtos Local|Listar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Produtos Colaborador|Listar',
  },
  {
    chave: PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Fardamentos Colaboradores|Listar',
  },
  {
    chave: PERMISSAO_TELA_CARTOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Cartões|Listar',
  },
  {
    chave: PERMISSAO_TELA_FLUXO_CAIXA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Fluxo de Caixa|Listar',
  },
  {
    chave: PERMISSAO_TELA_SCORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Scores|Listar',
  },
  {
    chave: PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Vendas Não Finalizadas|Listar',
  },
  {
    chave: PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Itens de Vendas Não Finalizados|Listar',
  },
  {
    chave: PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Relatórios|Compras Fiscais|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_COLABORADORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Colaboradores|Listar',
  },
  {
    chave: PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Modelos de Documentos|Listar',
  },
  {
    chave: PERMISSAO_TELA_DOCUMENTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Documentos|Listar',
  },
  {
    chave: PERMISSAO_TELA_FUNCOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Funções|Listar',
  },
  {
    chave: PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Checagem Camisas|Listar',
  },
  {
    chave: PERMISSAO_TELA_FARDAMENTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Fardamentos|Listar',
  },
  {
    chave: PERMISSAO_TELA_FERIADOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Feriados|Listar',
  },
  {
    chave: PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Tamanhos Fardamentos|Listar',
  },
  {
    chave: PERMISSAO_TELA_QUALIDADES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Qualidades|Listar',
  },
  {
    chave: PERMISSAO_TELA_DEFEITOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Defeitos|Listar',
  },
  {
    chave: PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Descontos de Funcionários|Listar',
  },
  {
    chave: PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Categorias de Descontos|Listar',
  },
  {
    chave: PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Grupos|Listar',
  },
  {
    chave: PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Equipes|Listar',
  },
  {
    chave: PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Codinomes|Listar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Produtos Codinomes|Listar',
  },
  {
    chave: PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|departamentos_colaboradores|Listar',
  },
  {
    chave: PERMISSAO_TELA_HORAS_EXTRAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Horas Extras|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_FREEZERS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Equipamentos|Freezers|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Meios de Pagamentos|Listar',
  },
  {
    chave: PERMISSAO_TELA_UNIDADES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Unidades|Listar',
  },
  {
    chave: PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Cargos|Listar',
  },
  {
    chave: PERMISSAO_TELA_USUARIOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Usuários|Listar',
  },
  {
    chave: PERMISSAO_TELA_PERGUNTAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Perguntas|Listar',
  },
  {
    chave: PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Categorias de Peguntas|Listar',
  },
  {
    chave: PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Categorias de Caixas|Listar',
  },
  {
    chave: PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Categorias de Problemas|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONFIGURACOES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Configurações|Listar',
  },
  {
    chave: PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Tutoriais|Listar',
  },
  {
    chave: PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Estados Brasileiros|Listar',
  },
  {
    chave: PERMISSAO_TELA_LOJAS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Lojas|Listar',
  },
  {
    chave: PERMISSAO_TELA_TABELA_IBPT_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Tabela IBPT|Listar',
  },
  {
    chave: PERMISSAO_TELA_NCMS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|NCMs|Listar',
  },
  {
    chave: PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Tabela CST IBS/CBS|Listar',
  },
  {
    chave: PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Tabela CClassTrib|Listar',
  },
  {
    chave: PERMISSAO_TELA_PERFIS,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Sistema|Perfis|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_FEATURES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Development|Features|Listar',
  },
  {
    chave: PERMISSAO_TELA_SOFTWARES_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Development|Softwares|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Conferências|Conferências de Freezers|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Coletor|Etiquetas de Gôndola|Listar',
  },
  {
    chave: PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR,
    status: STATUS_ATIVO,
    descricao:
      'Gerencial|Coletor|Coneferência de Temperatura de Freezers|Listar',
  },
  {
    chave: PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Coletor|Cartazes de Oferta|Listar',
  },
  //
  {
    chave: PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Desenvolvedor|Logs Relatórios|Listar',
  },
  {
    chave: PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Desenvolvedor|Dados Fiscais Checkouts|Listar',
  },
  {
    chave: PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Desenvolvedor|Computadores Autorizados|Listar',
  },
];

// Permissão de ação da tela de Documentos: migration própria, fora do seed histórico.
const permissoesAcoesDocumentos = [
  {
    chave: PERMISSAO_TELA_DOCUMENTOS_EXCLUIR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Contabilidade|Documentos|Excluir',
  },
];

// Permissões de ação da tela de Produtos: têm migration própria (não entram no seed histórico
// `permissoesMigration1`), mas precisam estar em `permissoes` para aparecerem na tela de Perfis.
const permissoesAcoesProdutos = [
  {
    chave: PERMISSAO_TELA_PRODUTOS_CRIAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Produtos|Criar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_INATIVAR,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Produtos|Inativar',
  },
  {
    chave: PERMISSAO_TELA_PRODUTOS_ABA_INATIVOS,
    status: STATUS_ATIVO,
    descricao: 'Gerencial|Itens de Venda|Produtos|Aba Inativos',
  },
];

const permissoes = [
  ...permissoesMigration1,
  ...permissoesAcoesProdutos,
  ...permissoesAcoesDocumentos,
];

export {
  PERMISSAO_TELA_ESCALAS_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_COLABORADOR_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR,
  PERMISSAO_TELA_FERIADOS_PESSOAL_LISTAR,
  PERMISSAO_TELA_GRADE_HORARIOS_LISTAR,
  PERMISSAO_TELA_QRCODES_GERENTE_CAIXA_LISTAR,
  PERMISSAO_TELA_TROCOS_TRANSPORTADOR_LISTAR,
  PERMISSAO_TELA_CONFIG_PRODUTOS_LISTAR,
  PERMISSAO_TELA_BANCOS_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_FUNCOES_FUNCIONARIOS_LISTAR,
  PERMISSAO_TELA_JORNAIS_OFERTAS_LISTAR,
  PERMISSAO_TELA_COTACOES_LISTAR,
  PERMISSAO_TELA_OFERTAS_ZERAR_ESTOQUE_LISTAR,
  PERMISSAO_TELA_PEDIDOS_COMPRAS_LISTAR,
  PERMISSAO_TELA_REPRESENTANTES_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_VENDAS_LISTAR,
  PERMISSAO_TELA_DEVOLUCOES_VENDAS_LISTAR,
  PERMISSAO_TELA_PEDIDOS_VENDAS_LISTAR,
  PERMISSAO_TELA_RATOEIRA_LISTAR,
  PERMISSAO_TELA_CREDITOS_DEVOLUCAO_VENDAS_LISTAR,
  PERMISSAO_TELA_PEDIDOS_LIBERACOES_PRECOS_LISTAR,
  PERMISSAO_TELA_APROVACOES_PEDIDOS_LIBERACAO_PRECOS_LISTAR,
  PERMISSAO_TELA_DESCARREGO_MERCADORIA_LISTAR,
  PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR,
  PERMISSAO_TELA_MAPAS_LOJA_LISTAR,
  PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR,
  PERMISSAO_TELA_NFCES_LISTAR,
  PERMISSAO_TELA_NFES_LISTAR,
  PERMISSAO_TELA_INDICADORES_NFE_LISTAR,
  PERMISSAO_TELA_INDICADORES_NFCE_LISTAR,
  PERMISSAO_TELA_INDICADORES_FISCAIS_LISTAR,
  PERMISSAO_TELA_COMPRAS_LISTAR,
  PERMISSAO_TELA_COMPRAS_INSUMOS_LISTAR,
  PERMISSAO_TELA_BONIFICACOES_LISTAR,
  PERMISSAO_TELA_COMPRAS_SERVICOS_LISTAR,
  PERMISSAO_TELA_NFES_CIENTES_LISTAR,
  PERMISSAO_TELA_NFES_PROBLEMATICAS_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_INSUMOS_LISTAR,
  PERMISSAO_TELA_FORNECEDORES_SERVICOS_LISTAR,
  PERMISSAO_TELA_OUTROS_CONTATOS,
  PERMISSAO_TELA_AGENDAMENTO_COMPRAS_FORNECEDORES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_LISTAR,
  PERMISSAO_TELA_FAMILIAS_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_LISTAR,
  PERMISSAO_TELA_TARAS_BALANCA_LISTAR,
  PERMISSAO_TELA_TABELA_LUCRO_LISTAR,
  PERMISSAO_TELA_BAIXAR_LISTAR,
  PERMISSAO_TELA_LOCAIS_LISTAR,
  PERMISSAO_TELA_SUGESTAO_PRODUTOS_LISTAR,
  PERMISSAO_TELA_SETORES_LISTAR,
  PERMISSAO_TELA_VERIFICACAO_CAIXARIA_LISTAR,
  PERMISSAO_TELA_LIBERACOES_PRECO_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_GRANDES_PESAGENS_LISTAR,
  PERMISSAO_TELA_HISTORICO_PRECIFICACOES_LISTAR,
  PERMISSAO_TELA_VERBAS_PRODUTOS_LISTAR,
  PERMISSAO_TELA_VALIDADES_LISTAR,
  PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR,
  PERMISSAO_TELA_MOVIMENTACAO_ESTOQUE_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_PRODUTOS_LISTAR,
  PERMISSAO_TELA_CLIENTES_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_CLIENTES_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_TEMPLATES_LISTAR,
  PERMISSAO_TELA_ATIVIDADES_LISTAR,
  PERMISSAO_TELA_DASHBOARD_LISTAR,
  PERMISSAO_TELA_SESSOES_LISTAR,
  PERMISSAO_TELA_CONTAS_LISTAR,
  PERMISSAO_TELA_CAIXAS_LISTAR,
  PERMISSAO_TELA_CONTAS_TABELA_LISTAR,
  PERMISSAO_TELA_VERIFICACAO_NOTAS_VENDAS_LISTAR,
  PERMISSAO_TELA_CARTOES_CREDITO_LISTAR,
  PERMISSAO_TELA_TRANSACOES_LISTAR,
  PERMISSAO_TELA_TRANSACOES_CONFERENCIA_LISTAR,
  PERMISSAO_TELA_PIX_LISTAR,
  PERMISSAO_TELA_TRANSFERENCIAS_LISTAR,
  PERMISSAO_TELA_AJUSTES_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR,
  PERMISSAO_TELA_FUTUROLOGIA_LISTAR,
  PERMISSAO_TELA_TRANSACOES_SIMULADAS_LISTAR,
  PERMISSAO_TELA_VENDAS_FATURADAS_LISTAR,
  PERMISSAO_TELA_AGENDAMENTOS_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_MAQUINETAS_LISTAR,
  PERMISSAO_TELA_IMPOSTOS_LISTAR,
  PERMISSAO_TELA_MALOTES_LISTAR,
  PERMISSAO_TELA_SUBMALOTES_LISTAR,
  PERMISSAO_TELA_SANGRIAS_LISTAR,
  PERMISSAO_TELA_TROCOS_LISTAR,
  PERMISSAO_TELA_SOBRAS_LISTAR,
  PERMISSAO_TELA_SINISTROS_LISTAR,
  PERMISSAO_TELA_CONTA_GERENCIAL_LISTAR,
  PERMISSAO_TELA_LIXEIRA_LISTAR,
  PERMISSAO_TELA_MENSAL_LISTAR,
  PERMISSAO_TELA_ANUAL_LISTAR,
  PERMISSAO_TELA_PRODUTOS_RELATORIO_LISTAR,
  PERMISSAO_TELA_CLIENTES_RELATORIO_LISTAR,
  PERMISSAO_TELA_INDICADORES_KPI_LISTAR,
  PERMISSAO_TELA_INVENTARIO_LISTAR,
  PERMISSAO_TELA_CADASTRO_CLIENTES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_LOCAL_LISTAR,
  PERMISSAO_TELA_PRODUTOS_COLABORADOR_LISTAR,
  PERMISSAO_TELA_FARDAMENTOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_CARTOES_LISTAR,
  PERMISSAO_TELA_FLUXO_CAIXA_LISTAR,
  PERMISSAO_TELA_SCORES_LISTAR,
  PERMISSAO_TELA_VENDAS_NAO_FINALIZADAS_LISTAR,
  PERMISSAO_TELA_ITENS_VENDA_NAO_FINALIZADOS_LISTAR,
  PERMISSAO_TELA_COMPRAS_FISCAIS_LISTAR,
  PERMISSAO_TELA_COLABORADORES_LISTAR,
  PERMISSAO_TELA_MODELOS_DOCUMENTOS_LISTAR,
  PERMISSAO_TELA_DOCUMENTOS_LISTAR,
  PERMISSAO_TELA_DOCUMENTOS_EXCLUIR,
  PERMISSAO_TELA_FUNCOES_LISTAR,
  PERMISSAO_TELA_CHECAGEM_CAMISAS_LISTAR,
  PERMISSAO_TELA_FARDAMENTOS_LISTAR,
  PERMISSAO_TELA_FERIADOS_LISTAR,
  PERMISSAO_TELA_TAMANHOS_FARDAMENTOS_LISTAR,
  PERMISSAO_TELA_QUALIDADES_LISTAR,
  PERMISSAO_TELA_DEFEITOS_LISTAR,
  PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR,
  PERMISSAO_TELA_CATEGORIA_DESCONTOS_LISTAR,
  PERMISSAO_TELA_GRUPOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_EQUIPES_COLABORADORES_LISTAR,
  PERMISSAO_TELA_CODINOMES_COLABORADORES_LISTAR,
  PERMISSAO_TELA_PRODUTOS_CODINOMES_LISTAR,
  PERMISSAO_TELA_DEPARTAMENTOS_COLABORADORES_LISTAR,
  PERMISSAO_TELA_HORAS_EXTRAS_LISTAR,
  PERMISSAO_TELA_FREEZERS_LISTAR,
  PERMISSAO_TELA_MEIO_PAGAMENTO_LISTAR,
  PERMISSAO_TELA_UNIDADES_LISTAR,
  PERMISSAO_TELA_CARGOS_SISTEMA_LISTAR,
  PERMISSAO_TELA_USUARIOS_LISTAR,
  PERMISSAO_TELA_PERGUNTAS_LISTAR,
  PERMISSAO_TELA_CATEGORIA_PERGUNTA_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_CAIXAS_LISTAR,
  PERMISSAO_TELA_CATEGORIAS_PROBLEMAS_LISTAR,
  PERMISSAO_TELA_CONFIGURACOES_LISTAR,
  PERMISSAO_TELA_VIDEOS_TUTORIAIS_FC_LISTAR,
  PERMISSAO_TELA_ESTADOS_BRASILEIROS_LISTAR,
  PERMISSAO_TELA_LOJAS_LISTAR,
  PERMISSAO_TELA_TABELA_IBPT_LISTAR,
  PERMISSAO_TELA_NCMS_LISTAR,
  PERMISSAO_TELA_TABELA_CST_IBSCBS_LISTAR,
  PERMISSAO_TELA_TABELA_CCLASSTRIB_LISTAR,
  PERMISSAO_TELA_PERFIS,
  PERMISSAO_TELA_FEATURES_LISTAR,
  PERMISSAO_TELA_SOFTWARES_LISTAR,
  PERMISSAO_TELA_CONFERENCIAS_FREEZERS_LISTAR,
  PERMISSAO_TELA_ETIQUETAS_GONDOLA_LISTAR,
  PERMISSAO_TELA_CONFERENCIA_TEMPERATURA_FREEZERS_LISTAR,
  PERMISSAO_TELA_CARTAZES_OFERTA_LISTAR,
  PERMISSAO_TELA_LOGS_RELATORIOS_LISTAR,
  PERMISSAO_TELA_DADOS_FISCAIS_CHECKOUT_LISTAR,
  PERMISSAO_TELA_RELATORIOS_FISCAIS_LISTAR,
  PERMISSAO_TELA_RELATORIOS_FISCAIS_GERAR,
  PERMISSAO_TELA_RELATORIOS_FISCAIS_REPROCESSAR_FORCADO,
  PERMISSAO_TELA_COMPUTADORES_AUTORIZADOS_LISTAR,
  PERMISSAO_TELA_CONTAS_TABELA_EDITAR,
  PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_COMPRADOR,
  PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_IMPOSTOS,
  PERMISSAO_TELA_PRODUTOS_DIALOGOS_ABA_FORNECEDOR,
  PERMISSAO_TELA_PRODUTOS_CRIAR,
  PERMISSAO_TELA_PRODUTOS_INATIVAR,
  PERMISSAO_TELA_PRODUTOS_ABA_INATIVOS,
  PERMISSAO_TELA_FORNECEDORES_DIALOGOS_ABA_COMPRADOR,
  PERMISSAO_TELA_PEDIDOS_COMPRAS_ACOES,
  permissoes,
};
